// initial state
const state = {
  room: {}
}

// getters
const getters = {}

// actions
const actions = {
  setRoom ({ commit }, room) {
    commit('setRoom', room)
  }
}

// mutations
const mutations = {
  setRoom (state, room) {
    state.room = room
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/payment.js